// The routes will automatically check the resource/action and show/hide them in the menus.
export const initialAbility = [
    {
        action: "read",
        subject: "auth",
    },
];

export const _ = undefined;
